+function(){
class PointQuickView extends BaseV2 {
  constructor() {
    super();
  }
  connectedCallback() {
    var config = this.dataset.config
    if (config) {
      window.globalQuickViewLock = window.globalQuickViewLock || {}
      this.config = JSON.parse(config)
      this.createPopupContainer()
      this.initPoints()
    }
  }
  disconnectedCallback() {
    this.removeEvents()
  }
  initEvents() {
    if (this.points.length) {
      this.bindMouseOver = this.onMouseOver.bind(this)
      this.bindMouseLeave = this.onMouseLeave.bind(this)
      this.bindPopperMouseOver = this.onPopperMouseOver.bind(this)
      this.bindModalOpen = this.handleModalOpen.bind(this)
      this.bindViewLoaded = this.handleViewLoaded.bind(this)
      this.bindClickOutside = this.onClickOutside.bind(this)
      if (!this.isMobile()) {
        this.popupContainer.addEventListener('mouseenter', this.bindPopperMouseOver)
        this.popupContainer.addEventListener('mouseleave', this.bindMouseLeave)
        document.addEventListener('modalOpen', this.bindModalOpen)
        document.addEventListener('quickview:loaded', this.bindViewLoaded)
      } else {
        window.addEventListener('scroll', this.bindMouseLeave)
        window.addEventListener('click', this.bindClickOutside)
      }
      for (const point of this.points) {
        if (!this.isMobile()) {
          point.addEventListener('mouseenter', this.bindMouseOver)
          point.addEventListener('mouseleave', this.bindMouseLeave)
        } else {
          point.addEventListener('touchstart', this.bindMouseOver)
        }
      }
    }
  }
  removeEvents() {
    if (this.points.length) {
      for (const point of this.points) {
        if (!this.isMobile()) {
          point.removeEventListener('mouseenter', this.bindMouseOver)
          point.removeEventListener('mouseleave', this.bindMouseLeave)
        } else {
          point.removeEventListener('touchstart', this.bindMouseOver)
        }
      }
      if (!this.isMobile()) {
        this.popupContainer.removeEventListener('mouseenter', this.bindPopperMouseOver)
        this.popupContainer.removeEventListener('mouseleave', this.bindMouseLeave)
        document.removeEventListener('modalOpen', this.bindModalOpen)
        document.removeEventListener('quickview:loaded', this.bindViewLoaded)
      } else {
        window.removeEventListener('scroll', this.bindMouseLeave)
        window.removeEventListener('click', this.bindClickOutside)
      }
    }
  }
  onClickOutside(e) {
    if (this.hoverPoint && !$.contains(this.hoverPoint, e.target)) {
      this.bindMouseLeave()
    }
  }
  createPopper(trigger) {
    var popperInstance = Popper.createPopper(trigger, this.popupContainer, {
      strategy: 'fixed',
      placement: this.isMobile() ? 'bottom' : 'left',
      modifiers: this.isMobile() ? [
        {
          name: 'offset',
          options: {
            offset: [-20, 0],
          },
        },
      ] : [],
    })
    this.popper = popperInstance
    popperInstance.update()
  }
  loadProduct(handle, onLoad) {
    var suffix = '?view=popup'
    if (handle.includes('?')) {
      suffix = '&view=popup'
    }
    var url = theme.routes.home + '/products/' + handle + suffix;
    url = url.replace('//', '/');
        fetch(url)
    .then(response => response.text())
    .then(text => {
      if (this.hoverPoint && this.hoverPoint.getAttribute('popper-show') == 'true' && this.popupContainer) {
        this.createPopper(this.hoverPoint)
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        this.popupContainer.innerHTML = ''
        const popupProduct = parsed.querySelector('.popup-product')
        this.popupProductId = popupProduct.dataset.productId
        this.popupProductHandle = handle
        this.popupContainer.appendChild(popupProduct)
        if (!this.isMobile()) {
          if (!window.globalQuickViewLock[handle] && !document.getElementById(`QuickShopModal-${this.popupProductId}`)) {
            window.globalQuickViewLock[handle] = true
            const modal = parsed.querySelector('.modal')
            document.body.appendChild(modal)
            this.preloadProductModal(false)
          } else {
            this.preloadProductModal(true)
          }
        }
        if (onLoad) {
          onLoad()
        }
      }
    })
  }
  handleViewLoaded(event) {
    if (event.detail.flickity) {
      setTimeout(() => {
        event.detail.flickity.resize()
      }, 300)
    }
    window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets && window.yotpoWidgetsContainer.initWidgets()
  }
  handleModalOpen(event) {
    if (event.detail == `QuickShopModal-${this.popupProductId}`) {
      if (this.hoverPoint) {
        const uuid = this.hoverPoint.getAttribute("uuid")
        if (this.timeouts[uuid]) {
          clearTimeout(this.timeouts[uuid])
          this.timeouts[uuid] = null
        }
      }
    }
  }
  hidePopup(afterHide) {
    this.popupContainer.classList.remove('animating')
    setTimeout(() => {
      this.popupContainer.classList.remove('show')
      if (this.popperInstance) {
        this.popperInstance.destroy()
        this.popperInstance = null
      }
      if (this.hoverPoint) {
        this.hoverPoint.setAttribute('popper-show', 'false')
        this.hoverPoint = null
      }
      if (afterHide) {
        afterHide()
      }
    }, 300)
  }
  onMouseLeave(event, afterHide) {
    if (this.hoverPoint && this.hoverPoint.getAttribute('popper-show') != 'false') {
      const uuid = this.hoverPoint.getAttribute("uuid")
      this.timeouts[uuid] = setTimeout(() => {
        this.hidePopup(afterHide)
      }, 150)
    }
  }
  onPopperMouseOver(event) {
    if (this.hoverPoint) {
      const uuid = this.hoverPoint.getAttribute("uuid")
      if (this.timeouts[uuid]) {
        clearTimeout(this.timeouts[uuid])
        this.timeouts[uuid] = null
      }
    }
  }
  preloadProductModal(onlyBind) {
    var handle = this.popupProductHandle
    var holder = document.getElementById('QuickShopHolder-' + handle)
    var url = window.route_prefix + "products/" + handle + "?view=modal";
    var btn = this.popupContainer.querySelector('.quick-product__btn')
    const bindModal = () => {
        // Setup quick view modal
        var modalId = 'QuickShopModal-' + this.popupProductId
        var name = 'quick-modal-' + this.popupProductId
        new theme.Modals(modalId, name)

        if (btn) {
          btn.classList.remove('quick-product__btn--not-ready')
        }
        window.globalQuickViewLock[handle] = false
    }
    if (!onlyBind) {
      fetch(url)
      .then(function (response) {
        return response.text()
      })
      .then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser()
        var doc = parser.parseFromString(html, 'text/html')
        var div = doc.querySelector(
          '.product-section[data-product-handle="' + handle + '"]'
        )
        if (!holder) {
          return
        }
        if (div.querySelector('.breadcrumb')) {
          div.querySelector('.breadcrumb').style.display = 'none'
        }
        var recommendSections = div.querySelectorAll('.product-recommend-section')
        if (recommendSections.length) {
          recommendSections.forEach(e => {
            e.parentElement.removeChild(e)
          })
        }
        holder.append(div)

        // Register product template inside quick view
        theme.sections.register('product', theme.Product, holder)

        // Register collapsible elements
        theme.collapsibles.init()

        // Register potential video modal links (when video has sound)
        theme.videoModal()
        bindModal()
      })
    } else {
      bindModal()
    }
  }
  onMouseOver(event) {
    if (event.cancelable) {
      event.preventDefault();
    }
    event.stopPropagation();
    var pointElement = event.target
    if (!pointElement.classList.contains('point-highlight-v2')) {
      pointElement = pointElement.closest('.point-highlight-v2')
    }
    $('.point-highlight-v2').attr('popper-show','false')
    const uuid = pointElement.getAttribute("uuid")
    if (this.timeouts[uuid]) {
      clearTimeout(this.timeouts[uuid])
      this.timeouts[uuid] = null
    }
    const show = () => {
      if (pointElement.getAttribute('popper-show') != 'true') {
        pointElement.setAttribute('popper-show', 'true')
        this.hoverPoint = pointElement
        this.loadProduct(pointElement.getAttribute('handle'), () => {
          this.popupContainer.classList.add('show')
          window.requestAnimationFrame(() => {
            this.popupContainer.classList.add('animating')
          })
        })
      }
    }
    const checkPreShow = () => {
      if (this.hoverPoint && this.hoverPoint.getAttribute('popper-show') == 'true' && this.hoverPoint != pointElement) {
        if (this.isMobile()) {
          this.bindMouseLeave(event, show)
        } else {
          setTimeout(() => {
            checkPreShow()
          }, 100)
        }
      } else {
        show()
      }
    }

    checkPreShow()
  }
  initPoints() {
    let points
    if (this.config.desktop && !this.isMobile()) {
      points = this.config.desktop
    } else if (this.config.mobile && this.isMobile()) {
      points = this.config.mobile
    } else {
      points = this.config
    }
    this.points = []
    let i = 0
    this.timeouts = {}
    for (const point of points) {
      i ++
      const pointDom = this.createPoint()
      pointDom.style.left = point.x
      pointDom.style.top = point.y
      pointDom.setAttribute('handle', point.handle)
      pointDom.setAttribute("uuid", i)
      this.points.push(pointDom)
      this.appendChild(pointDom)
      this.timeouts[i] = null
    }
    this.initEvents()
  }
  createPopupContainer() {
    if (!document.querySelector('.highlight-tooltip')) {
      const parent = document.createElement('div')
      parent.classList.add('highlight-tooltip')
      parent.id = 'product-highlight-tooltip'
      document.body.appendChild(parent)
      this.popupContainer = parent
    } else {
      this.popupContainer = document.querySelector('.highlight-tooltip')
    }
    // parent.innerHTML = `
    //   <div id="product-highlight-tooltip" class="highlight-tooltip">
    //     <a href="/products/the-vego-grow-light">
    //       <div class="highlight-tooltip-content">
    //         <div class="tooltip-head">
    //           {% render 'picture-hd-simple', image: images['main.png'] %}
    //         </div>
    //         <div class="tooltip-body">
    //           <div class="tooltip-title">The Vego Grow Light</div>
    //           <div class="tooltip-desc">
    //             Bring natural sunlight indoors with the Vego Grow Light, the smartest way to grow thriving plants indoors.
    //           </div>
    //         </div>
    //         <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
    //           <path d="M1 1L7 7L0.999999 13" stroke="#3A5B39" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    //         </svg>
    //       </div>
    //     </a>
    //   </div>
    // `
  }
  createPoint() {
    const parent = document.createElement('div')
    parent.innerHTML = `
      <a class="why-dot-circle point-highlight-v2" data-target="#product-highlight-tooltip">
        <span class="why-dot" for="Safety Features"> </span>
      </a>
    `
    return parent.children[0]
  }
}
if (!customElements.get('vego-point-quick-view')) {
  customElements.define('vego-point-quick-view', PointQuickView);
}

}()